// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"styles__container___1bP5m","backdrop":"styles__backdrop___29G3z","modal":"styles__modal___1bmtM","dialog":"styles__dialog___2N5T9","form":"styles__form___d2kd4","icon":"styles__icon___qXtOC","cancel-btn":"styles__cancel-btn___8vw9u","cancelBtn":"styles__cancel-btn___8vw9u"};
    if(module.hot) {
      // 1767750389522
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  